export default __webpack_public_path__ + "static/media/radio-checked-green.b8a20020.svg";